import React from 'react';
import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import textTypes from '../textLabel/textTypes';
import TextLabel from '../textLabel/textLabel';
var DEFAULT_SYMBOL_SIZE = 27;
var AddThumbnailButton = function AddThumbnailButton(props) {
  return /*#__PURE__*/React.createElement("div", {
    "data-hook": props.dataHook,
    className: props.getClassName('add-thumbnail-button'),
    onClick: props.onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "add-thumbnail-symbol-container",
    style: props.style
  }, /*#__PURE__*/React.createElement("div", {
    className: "add-thumbnail-symbol",
    style: {
      width: props.symbolSize,
      height: props.symbolSize
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "horizontal-line"
  }), /*#__PURE__*/React.createElement("div", {
    className: "vertical-line"
  }))), props.label ? /*#__PURE__*/React.createElement(TextLabel, {
    key: "label",
    className: "add-thumbnail-label",
    value: props.label,
    type: props.labelType,
    shouldTranslate: props.shouldTranslate
  }) : null);
};
AddThumbnailButton.displayName = displayNames.ADD_THUMBNAIL_BUTTON;
AddThumbnailButton.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** onClick */
  onClick: PropTypes.func.isRequired,
  /** label */
  label: PropTypes.string,
  /** labelType */
  labelType: PropTypes.string,
  /** style */
  style: PropTypes.object,
  /** symbolSize */
  symbolSize: PropTypes.number,
  /** isFirst */
  isFirst: PropTypes.bool
};
AddThumbnailButton.defaultProps = {
  labelType: textTypes.THUMBNAIL_LABEL_DEFAULT_TYPE,
  symbolSize: DEFAULT_SYMBOL_SIZE
};
export default compose(AddThumbnailButton);